export const getQvctAnswerMark = (state) => state.qvctAnswerMark

